import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from './api-base.service';
import ApiOptionsConfig from './api-options.config';

const BASE_URL_CAMPAIGNS = '/campaigns';
@Injectable({
  providedIn: 'root'
})
export class CampaignsService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL_CAMPAIGNS), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL_CAMPAIGNS), data);
  }

  update(campaignId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL_CAMPAIGNS}/${campaignId}`), data);
  }

   detail(campaignId: number): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_CAMPAIGNS}/${campaignId}`));
  }
  
  delete(campaignId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL_CAMPAIGNS}/${campaignId}`));
  }

 

}
